var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DialogUpdateProfileUser__Component" }, [
    _c(
      "form",
      {
        attrs: { novalidate: "true" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.updateFullName($event)
          }
        }
      },
      [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v("עדכון שם משתמש")
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close", true)
                }
              }
            })
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "b-field",
                { attrs: { label: "שם משתמש" } },
                [
                  _c("b-input", {
                    attrs: { disabled: _vm.isLoading },
                    model: {
                      value: _vm.fullName,
                      callback: function($$v) {
                        _vm.fullName = $$v
                      },
                      expression: "fullName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "footer",
          { staticClass: "modal-card-foot" },
          [
            _c("b-button", {
              attrs: {
                "native-type": "submit",
                loading: _vm.isLoading,
                label: "שמור",
                type: "is-primary"
              }
            }),
            _c("b-button", {
              attrs: { loading: _vm.isLoading, label: "סגור" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }